<div class="row table-row">
    <div class="col-md-2">{{ translateType(form.controls.type.value) }}</div>
    <div class="col-md-2">{{ form.controls.name.value }}</div>
    <div class="col-md-4">{{ form.controls.description.value }}</div>
    <div class="col-md-2">
        {{ form.controls.pricePerSession.value | amount }}
    </div>
    <div class="col-md-2">
        @if (state.canEdit | async) {
            <button
                class="btn btn-action btn-primary pull-right"
                [disabled]="isOtherItemEdited"
                bcClick
                (clicked)="edit()"
            >
                {{ "General.Edit" | translate }}
            </button>
        }
        @if (state.canEdit | async) {
            <button
                class="btn btn-danger btn-action pull-right mr-1"
                [disabled]="isOtherItemEdited"
                bcClick
                (clicked)="remove()"
            >
                {{ "General.Remove" | translate }}
            </button>
        }
    </div>
</div>
